var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.75C17.0711 14.75 18.75 13.0711 18.75 11C18.75 8.92893 17.0711 7.25 15 7.25C12.9289 7.25 11.25 8.92893 11.25 11C11.25 13.0711 12.9289 14.75 15 14.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0063 10.6812C27.9037 7.82905 25.9895 5.36245 23.5002 3.58633C21.011 1.81021 18.0559 0.802412 15.0001 0.6875C11.9443 0.802412 8.9892 1.81021 6.49997 3.58633C4.01073 5.36245 2.09649 7.82905 0.993839 10.6812C0.919371 10.8872 0.919371 11.1128 0.993839 11.3188C2.09649 14.171 4.01073 16.6375 6.49997 18.4137C8.9892 20.1898 11.9443 21.1976 15.0001 21.3125C18.0559 21.1976 21.011 20.1898 23.5002 18.4137C25.9895 16.6375 27.9037 14.171 29.0063 11.3188C29.0808 11.1128 29.0808 10.8872 29.0063 10.6812V10.6812ZM15.0001 17.0938C13.7949 17.0937 12.6167 16.7364 11.6146 16.0668C10.6125 15.3972 9.83142 14.4455 9.3702 13.332C8.90898 12.2185 8.7883 10.9932 9.02343 9.81117C9.25856 8.6291 9.83893 7.54329 10.6912 6.69107C11.5434 5.83884 12.6292 5.25847 13.8113 5.02334C14.9933 4.78821 16.2186 4.90889 17.3321 5.37011C18.4456 5.83133 19.3973 6.61238 20.0669 7.61449C20.7364 8.61661 21.0938 9.79477 21.0938 11C21.0914 12.6154 20.4485 14.1639 19.3063 15.3062C18.164 16.4485 16.6155 17.0913 15.0001 17.0938V17.0938Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisits);
export default __webpack_public_path__ + "static/media/visits.0c3f509a2c6ea07597fd903fdc664119.svg";
export { ForwardRef as ReactComponent };